import { CircularProgress } from '@mui/material'

const AppLoader = () => (
  <CircularProgress size={'3.5rem'} />
)

export default AppLoader
